import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { ImCross } from 'react-icons/im';

const AddBankModal = ({show,setBankInfos, handleClose, handleSubmit, errorMessage,  workerData,setIsSubmit ,bankinfos,isSubmit}) => {

   
    return (
        <>





            <Modal backdrop="static"
                keyboard={false} show={show} centered onHide={handleClose} className='deleteModal'  >

                <div className="border border-primary border-4">
                    <Modal.Header closeButton className='bg-primary text-white'>
                        <Modal.Title>Bank {workerData?.createdAt ? "Edit" : "Add"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >

                        <div className="row">
                            <form>


                                <div className="row">
                                    <div className="col-md-8 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="" className="form-lbl">
                                                Bank Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-g1"
                                                id="form-request*"
                                                name="bank_name"
                                                onChange={(e) => {
                                                    setIsSubmit(false)
                                                    setBankInfos({ ...bankinfos, bank_name: e.target.value })
                                                }}
                                                value={bankinfos?.bank_name}
                                                placeholder="Bank Name"
                                            />
                                        </div>
                                        {bankinfos?.bank_name == "" && (
                                            <div
                                                className="error error-message"
                                                style={{ color: "red" }}
                                            >
                                                {errorMessage}
                                            </div>
                                        )}
                                    </div>
                                </div>



                                <div className="row">
                                    {bankinfos?.account_number?.map((an, ind) => (
                                        <>
                                            <div div className="col-md-6 mb-2 position-relative">
                                                <div className="form-group">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <label htmlFor="" className="form-lbl">
                                                            Account Number
                                                        </label>
                                                        {bankinfos?.account_number.length > 1 && (
                                                            <ImCross
                                                                className="cross__btn-bank"
                                                                onClick={(e) => {
                                                                    setIsSubmit(false)
                                                                    setBankInfos({ ...bankinfos, account_number: bankinfos.account_number.filter((an, i) => (i !== ind)) })
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-g1"
                                                        id="form-request*"
                                                        name="account_no"

                                                        onChange={(e) => {
                                                            setIsSubmit(false)
                                                            setBankInfos({
                                                                ...bankinfos, account_number: bankinfos.account_number.map((an, i) => (i === ind ? e.target.value.replace(/[^0-9]/g,"") : an
                                                                ))
                                                            })
                                                        }
                                                        }
                                                        value={an}
                                                        placeholder="Bank Account Number"
                                                    />


                                                    {isSubmit && <div
                                                        className="error error-message"
                                                        style={{ color: "red" }}
                                                    >
                                                        {an === "" &&`  please fill with account number` }
                                                    </div>}


                                                </div>
                                            </div>
                                        </>
                                    ))}
                                    <div className="col-md-6 d-flex">
                                        <>
                                            <div className="pb-3 me-2  d-flex align-items-end ">
                                                <button
                                                    type="button"
                                                    className="px-3 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                                                    onClick={(e) => setBankInfos({ ...bankinfos, account_number: [...bankinfos.account_number, ""] })}
                                                >
                                                    Add Number
                                                </button>
                                            </div>
                                        </>

                                    </div>
                                </div>






                            </form>
                        </div>
                        {errorMessage?.global && (
                            <div
                                className="error error-message"
                                style={{ color: "red" }}
                            >
                                {errorMessage?.global}
                            </div>
                        )}

                        <div className="d-flex justify-content-between mt-3">

                            <button onClick={handleClose} className='ms-0 btn px-4 close__button'>
                                <p className='mb-0 px-4'>  Cancel</p>
                            </button>
                            <button onClick={handleSubmit} className='px-5 btn-primary'>
                                <p className='mb-0 px-4'>  Ok</p>
                            </button>
                        </div>

                    </Modal.Body>




                </div>

            </Modal>
        </>
    )
}

export default AddBankModal